import { AppConfigData } from "@mavles/shared";
import { IAddress } from "../hrm/contacts";

export class Customer {
    constructor() {
        this.billing_address = new Address();
        this.shipping_address = new Address();
    }
    customer_id!: number;
    customer_name!: string;
    customer_email!: string;
    customer_phone!: number;
    customer_website!: string;
    customer_facebook!: string;
    customer_type!: number;
    customer_notes!: number;
    created_by!: number;
    created_date!: string;
    updated_by!: number;
    updated_date!: string;
    deleted_at!: number;
    billing_address_id!: number;
    billing_address!:Address;
    shipping_address_id!: number;
    shipping_address!:Address;

    payment_received!: number;
    last_payment!: number;
    payment_due!: number;
    payment_invoiced!: number;

    customer_gst!: string;
    customer_status!: number;

}

export class Address implements IAddress{

    constructor(data?:any) {
        // Object.assign(this, data);
        AppConfigData.config$?.subscribe(d=>{
          this.address_type = d.addressTypes[0];
        });
        if(data) {
            Object.keys(this).forEach(key => console.log(key));
        }
    }

    address_type!: string;
    address_id!: number;
    address_street!: string;
    address_street_2!: string;
    address_city!: string;
    address_state = 'TN';
    address_pin_code!: number;
    created_by!: number;
    created_date!: Date;
    updated_by!: number;
    updated_date !: Date;
    address_delete = false;
}

